import styled from 'styled-components';
import { mixins } from '../../css';
import { alertYellow, colorGrey } from '../../css/colors';

export const AlertBox = styled.div`
  padding: ${mixins.pxToRem(20)};
  background-color: ${alertYellow};
`;

export const AlertContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const AlertText = styled.div`
  align-self: center;
  margin-left: ${mixins.pxToRem(10)};
  font-size: ${mixins.pxToRem(16)};
  font-family: AvenirNextLTPro-Regular, arial, helvetica, verdana, sans-serif;
  line-height: 1.5rem;
  color: ${colorGrey};
  text-transform: none;
`;
